export const CANONICAL_PUBLIC_ORIGIN = "https://beamstream.org";
const CANONICAL_PUBLIC_HOST = new URL(CANONICAL_PUBLIC_ORIGIN).hostname;

type PublicUrlOptions = {
  currentOrigin?: string;
  isProduction?: boolean;
  baseUrl?: string;
};

function browserOrigin(): string {
  return typeof window !== "undefined" ? window.location.origin : "";
}

export function canBootPublicApp(
  hostname: string,
  isProduction = import.meta.env.PROD,
): boolean {
  if (!isProduction) return true;
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, "");
  return normalizedHostname === CANONICAL_PUBLIC_HOST;
}

export function resolvePublicAppOrigin(
  currentOrigin = browserOrigin(),
  isProduction = import.meta.env.PROD,
): string {
  if (isProduction) return CANONICAL_PUBLIC_ORIGIN;
  return currentOrigin.replace(/\/+$/, "");
}

export function buildPublicAppUrl(
  path: string,
  options: PublicUrlOptions = {},
): string {
  const origin = resolvePublicAppOrigin(
    options.currentOrigin,
    options.isProduction,
  );
  const baseUrl = options.baseUrl ?? import.meta.env.BASE_URL ?? "/";
  const normalizedBase = `/${baseUrl.replace(/^\/+|\/+$/g, "")}`;
  const base = normalizedBase === "/" ? "/" : `${normalizedBase}/`;
  const normalizedPath = path.replace(/^\/+/, "");
  return `${origin}${base}${normalizedPath}`;
}
